import { withAuthFetch } from "myscore-shared-components";

const loginPage =
  process.env.VUE_APP_MYSCORE_LOGIN_PAGE ||
  "https://www.jwpepper.com/sheet-music/my_score/ms-login.jsp";

export const AuthenticatedFetch = withAuthFetch(loginPage);
